import React, { useMemo } from "react"

import { CoverageCheckResponseType } from "@common-shared/config/coverage.config"
import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { CHECKER_CONFIG } from "../../config/checker.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const NetworkBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    const isActivePlanStatus = useMemo<boolean>(() => {
        return (
            !!props.coverageResult.planStatus &&
            CHECKER_CONFIG.activePlanStatuses.includes(
                props.coverageResult.planStatus,
            )
        )
    }, [props.coverageResult])

    // When the coverage result has the isInNetworkCheck property,
    // we will display a badge indicating whether the plan is in-network or out-of-network.
    // If the property is not present, we will not display any badge.
    // We will also not display the badge if the response type is SCAN or DISCOVER,
    // as these response types do not provide network information.
    return typeof props.coverageResult.isInNetworkCheck !== "undefined" &&
        ![
            CoverageCheckResponseType.SCAN,
            CoverageCheckResponseType.DISCOVER,
        ].includes(props.coverageResult.responseType)
        ? HtmlHelper.getHtmlWrappedBadge(
              props.coverageResult.isInNetworkCheck
                  ? "INN Benefits"
                  : "OON Benefits",
              undefined,
              undefined,
              undefined,
              isActivePlanStatus
                  ? "bg-brand-lilacLight border-brand-lilac"
                  : undefined,
          )
        : null
}
